/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { Box, Divider, Grid, makeStyles } from '@material-ui/core';
// import { editTemplateTitle } from 'src/store/modules/template';
import { useDispatch, useSelector } from 'react-redux';

import Text from './Text';
import Button from './Button';
import { RootState } from 'src/store';
import { TEMPLATES_EDITOR_REGARCY } from 'src/constants/templates';
import EditMulti from 'src/components/editor/EditMultiRegurcy';
import AutoOnOffSwitches from 'src/components/editor/OnOffSwitch';

const useStyles = makeStyles(() => ({
  root: {
    width: '20rem',
    minWidth: '20rem',
    position: 'relative'
  },
  tabScroll: {
    width: '20rem',
    minWidth: '20rem',
    height: 'calc(100vh - 6.94rem)',

    display: 'flex',
    flexDirection: 'column',
    overflow: 'scroll',
    backgroundColor: '#ffffff',

    scrollbarWidth: 'none',
    scrollbarHeight: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  tabsWrapper: {
    width: '100%',
    minHeight: '3.94rem',

    backgroundColor: '#fff'
  },
  tabs: {
    minHeight: '3.94rem',
    padding: '0 1rem',

    display: 'flex',
    // overflowX: 'scroll',
    gap: '1rem',

    color: '#bebebe',
    fontFamily: 'Archivo',
    fontSize: '0.875rem',

    scrollbarWidth: 'none',
    scrollbarHeight: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },

  actTab: {
    cursor: 'pointer',
    display: 'flex',
    margin: 'auto 0',
    flexDirection: 'column',

    color: '#000',
    fontWeight: 700,
    letterSpacing: '0.02em'
  },
  tab: {
    cursor: 'pointer',
    display: 'flex',
    margin: 'auto 0',
    flexDirection: 'column',

    fontWeight: 700,
    letterSpacing: '0.02em'
  }
}));

const NavRight: FC = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState<string>('contents');
  var currentTemplate = useSelector(
    (state: RootState) => state.template.templateTitle
  );

  const tabs = [
    { value: 'contents', label: 'CONTENTS' },
    { value: 'button', label: 'BUTTON' }
  ];

  const handleTabsChange = (value: string): void => {
    setCurrentTab(value);
  };

  // useEffect(() => {
  //   dispatch(
  //     editTemplateTitle(
  //       window.location.pathname
  //         .split('/')[2]
  //         .toUpperCase()
  //         .split('-')
  //         .join(' ')
  //     )
  //   );
  // }, []);

  return (
    <div className={classes.root}>
      <div className={classes.tabsWrapper}>
        <div className={classes.tabs}>
          {tabs.map(tab => (
            <div
              key={tab.value}
              className={
                currentTab === tab.value ? classes.actTab : classes.tab
              }
              onClick={() => handleTabsChange(tab.value)}
            >
              {tab.value.toUpperCase()}
            </div>
          ))}
        </div>
        <Divider />
      </div>
      <Grid className={classes.tabScroll}>
        <Box>
          {TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.multi && (
            <>
              <EditMulti
              // datas={
              //   bgImage?.multi_image?.length || text?.multi_text?.length
              // }
              // multiDatas={TEMPLATE_LIST_ARRAY?.[currentTemplate]?.multi}
              // editDatas={TEMPLATE_LIST_ARRAY?.[currentTemplate]}
              />
              <AutoOnOffSwitches />
            </>
          )}
          {currentTab === 'contents' &&
            TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.text && (
              <Text datas={TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.text} />
            )}
          {currentTab === 'button' &&
            TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.button && (
              <Button
                datas={TEMPLATES_EDITOR_REGARCY?.[currentTemplate]?.button}
              />
            )}
        </Box>
      </Grid>
    </div>
  );
};

export default NavRight;
